import NotFound from './NotFound'

// eslint-disable-next-line import/no-unused-modules
export default NotFound
